import React, { useState, useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { PopupOption } from '../../components/Popup/PopupOption';
import {
  getOrgs,
  invokeDeleteOrgModal,
  setCurrentOrg,
} from '../../store/orgs/orgs.actions';
import { RootState } from '../../store/store';
import { Organization } from '../../types';
import { InvitationStatus } from '../Users/components/Table/components/InvitationStatus';
import { Options } from '../Users/components/Table/components/Options';

export type OrgRow = {
  key: string;
  name: string;
  url: string;
  email: string;
  invitationSent?: 'sent' | 'expired';
  options: Organization;
};

export const getCols = (
  options: JSX.Element[],
  findCurrentOrg: (org: Organization) => void
) => [
  {
    title: 'Organization name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'URL',
    dataIndex: 'url',
    key: 'url',
  },
  {
    title: 'Primary email address',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: '',
    dataIndex: 'invitationSent',
    key: 'invitationSent',
    render: (status: 'sent' | 'expired'): JSX.Element | null =>
      status ? <InvitationStatus status={status} /> : null,
  },
  {
    title: '',
    dataIndex: 'options',
    key: 'options',
    render: (org: Organization): JSX.Element => (
      <div onClick={() => findCurrentOrg(org)}>
        <Options options={options} />
      </div>
    ),
  },
];

export const useOrgTable = () => {
  const [selectedRows, setSelectedRows] = useState<OrgRow[]>([]);
  const [editOpen, setEditOpen] = useState(false);
  const { orgs } = useSelector((state: RootState) => state.orgs);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!orgs.length) dispatch(getOrgs());
  });

  const handleSelect = (keys: React.Key[], rows: OrgRow[]): void => {
    setSelectedRows(rows);
  };

  const rowSelection = {
    onChange: handleSelect,
  };

  const handleDelete = () => {
    dispatch(invokeDeleteOrgModal());
  };

  const handleEdit = () => {
    setEditOpen(!editOpen);
  };

  const options: JSX.Element[] = [
    <PopupOption
      className="options__option"
      text="Edit organization"
      onChoose={handleEdit}
    />,
    <PopupOption
      className="options__option options__red"
      text="Delete organization"
      onChoose={handleDelete}
    />,
  ];

  const cols = getCols(options, (org: Organization) =>
    dispatch(setCurrentOrg(org))
  );

  return {
    rowSelection,
    handleSelect,
    selectedRows,
    cols,
    orgs,
    handleDelete,
    editOpen,
    handleEdit,
  };
};
